<form [formGroup]="form">
  <div class="p-fluid">
    <kodit-field fieldLabel="Tip transakcije">
      <kodit-tip-transakcije-uplata-dropdown
        [formCtrl]="form.controls.tipTransakcije"
        formCtrlId="tip-transakcije"
      ></kodit-tip-transakcije-uplata-dropdown>
    </kodit-field>

    <kodit-field
        fieldLabel="Iznos uplate"
        fieldLabelFor="iznos-uplate"
      >
        <kodit-number-input
          formCtrlId="iznos-uplate"
          [formCtrl]="form.controls.iznosUplate"
        ></kodit-number-input>
      </kodit-field>
  </div>
</form>
